function getCategoryRowSpan(categoryWithItems = {}, variationIds = []) {
  const { items: categoryItems = [] } = categoryWithItems;

  return categoryItems.reduce((acc, item) => {
    const { variations: itemVariations = [] } = item;
    const teamMemberItemVariations = itemVariations.filter(({ id }) => variationIds.includes(id));
    return acc + teamMemberItemVariations.length;
  }, 0);
}

export function createTableRows(teamMemberServiceItems = [], categoriesWithItems = []) {
  const variationIds = teamMemberServiceItems.map(({ itemVariation }) => itemVariation);
  const rows = [];

  const processedCategories = new Set();
  const processedCategoryItems = new Set();

  categoriesWithItems.forEach((category) => {
    const { items: categoryItems = [], name: categoryName, id: categoryId } = category;
    const categoryRowSpan = getCategoryRowSpan(category, variationIds);

    categoryItems.forEach((item) => {
      const { variations: itemVariations = [], name: itemName, id: itemId } = item;
      const teamMemberItemVariations = itemVariations.filter(({ id }) => variationIds.includes(id));

      teamMemberItemVariations.forEach((variation) => {
        const { id: variationId, name: variationName, price, priceDisplay } = variation;
        const teamMemberServiceItem = teamMemberServiceItems.find(({ itemVariation }) => {
          return itemVariation === variationId;
        });

        const { id, priceOverride, priceDisplayOverride } = teamMemberServiceItem;
        const row = {
          key: `${categoryId}-${itemId}-${variationId}`,
          id,
          itemVariation: variationId,
          variationName,
          price,
          priceDisplay,
          priceOverride,
          priceDisplayOverride,
        };

        if (!processedCategories.has(categoryId)) {
          row.categoryName = categoryName;
          row.categoryRowSpan = categoryRowSpan;
          processedCategories.add(categoryId);
        }
        if (!processedCategoryItems.has(`${categoryId}-${itemId}`)) {
          row.itemName = itemName;
          row.itemRowSpan = teamMemberItemVariations.length;
          processedCategoryItems.add(`${categoryId}-${itemId}`);
        }
        rows.push(row);
      });
    });
  });

  return rows;
}
